import {FC, useEffect} from 'react'
import {useDispatch} from 'react-redux'
import {useHistory} from 'react-router-dom'
import {LoadingPage} from 'components/ui/LoadingPage'
import {generateDynamicPath, MYPAGE_PATHS} from 'consts/paths'
import {useStartProcedureStatus} from 'features/procedures/hooks/useStartProcedureStatus'
import {useSelector} from 'hooks/redux'
import {asyncError} from 'store/actions/asyncError'
import {useNotify} from 'hooks/useNotify'

export const Index: FC = () => {
  const dispatch = useDispatch()
  const notify = useNotify()
  const history = useHistory()
  const currentEmployee = useSelector((state) => state.session.currentUser.employee)
  const [startProcedureStatus] = useStartProcedureStatus()

  useEffect(() => {
    if (!currentEmployee) {
      notify('エラーが発生しました', 'error')
      history.replace('/dashboard')
      return
    }

    ;(async () => {
      try {
        const res = await startProcedureStatus({
          variables: {
            input: {
              employeeId: `${currentEmployee.id}`,
              procedureType: 'parental_leave',
              status: 'employee_draft',
              initialized: false,
            },
          },
        })
        const id = res.data?.startProcedureStatus.procedureStatus.id
        if (id) {
          history.replace(
            generateDynamicPath(MYPAGE_PATHS.PROCEDURES.PARENTAL_LEAVE.FLOW, [{pattern: 'id', replacement: id}])
          )
        }
      } catch (err) {
        dispatch(asyncError(err))
      }
    })()
  }, []) // oxlint-disable-line react/exhaustive-deps

  return <LoadingPage />
}
